var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCountingbabies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-abacus",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "642") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    className: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 1.000000)",
    fill: "#ffffff",
    className: "si-glyph-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.194,13.958 L1.765,13.958 C0.316,13.958 0.036,12.808 0.036,11.394 L0.036,2.607 C0.036,1.193 0.315,0.043 1.765,0.043 L14.194,0.043 C15.642,0.043 15.922,1.193 15.922,2.607 L15.922,11.394 C15.922,12.808 15.643,13.958 14.194,13.958 L14.194,13.958 Z M1.923,1 C1.414,1 1,1.426 1,1.948 L1,12.052 C1,12.574 1.414,13 1.923,13 L14.077,13 C14.586,13 15,12.574 15,12.052 L15,1.948 C15,1.426 14.586,1 14.077,1 L1.923,1 L1.923,1 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 0,
    width: 0.948,
    height: 13.068,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 0,
    width: 0.948,
    height: 13.068,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    width: 0.948,
    height: 13.068,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.438,
    cy: 4.976,
    rx: 1.438,
    ry: 0.976,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.438,
    cy: 7.976,
    rx: 1.438,
    ry: 0.976,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.438,
    cy: 10.976,
    rx: 1.438,
    ry: 0.976,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.477,
    cy: 2.976,
    rx: 1.477,
    ry: 0.976,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.477,
    cy: 5.976,
    rx: 1.477,
    ry: 0.976,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.477,
    cy: 10.976,
    rx: 1.477,
    ry: 0.976,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.435,
    cy: 7.977,
    rx: 1.435,
    ry: 0.977,
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.435,
    cy: 10.977,
    rx: 1.435,
    ry: 0.977,
    className: "si-glyph-fill"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountingbabies);
export default __webpack_public_path__ + "static/media/countingbabies.4ad09696f7621e859cdcdbe6e5406c79.svg";
export { ForwardRef as ReactComponent };